var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterOutline = function SvgTwitterOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.712 14.622 24.413 7h-1.587l-5.819 6.618L12.36 7H7l7.027 10.007L7 25h1.588l6.144-6.989L19.64 25H25l-7.288-10.378Zm-2.175 2.474-.712-.997L9.16 8.17h2.44l4.571 6.4.712.996 5.943 8.319h-2.439l-4.85-6.788Z",
    fill: "#053249"
  })));
};
export default SvgTwitterOutline;